import React from "react";
import PropTypes from "prop-types";

import { useScreen } from "hooks";
import Placeholder from "components/Placeholder";

import useStyles from "./useStyles";

const PlaceholderIdentity = ({ type, icon }) => {
  const classes = useStyles();
  const { isMobile } = useScreen();

  return (
    <>
      {isMobile ? (
        <div className={classes.row}>
          <div className={classes.service}>
            <Placeholder variant="circle" className={classes.imagePlaceholder} />
            <img src={icon} alt={`loading ${type}`} className={classes.service} />
          </div>
          <div className={classes.service}>
            <Placeholder variant="text" className={classes.placeholder} />
            <Placeholder variant="text" className={classes.placeholder} />
          </div>
        </div>
      ) : (
        <div className={classes.row}>
          <div className={classes.service}>
            <Placeholder variant="circle" className={classes.imagePlaceholder} />
            <img src={icon} alt={`loading ${type}`} />
            <Placeholder variant="text" className={classes.placeholder} />
          </div>

          <Placeholder variant="text" className={classes.placeholder} />
        </div>
      )}
    </>
  );
};

PlaceholderIdentity.propTypes = {
  type: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default PlaceholderIdentity;
